export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/hire-banner-bg-a6c0e4c8505cb4983fb5e68a1c5e07cb.png";